
/**
 * src/web/components/kpi-chart-page.jsx
 * kpi-pageの一覧から選択されたKPIの進捗状況ページ
 */

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import connect, {
  calcHighchartData,
  filterMonthlyProgress,
  calcComparisonHighchartData,
  calcColumnLineHighchartData,
  calcPieHighchartData
 } from '../../connects/kpi-chart-page'
import ChartView from 'react-highcharts'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import {
  List,
  ListItem,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  Card,
  CardText,
} from 'react-toolbox/lib/card'
import DatePicker from './date-picker.jsx'
import DropDown from 'react-toolbox/lib/dropdown'
import moment from 'moment'
import Checkbox from 'react-toolbox/lib/checkbox'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import tabTheme from './themes/diary-forms-tab.css'
import kpiTheme from './themes/kpi.css'
import newUserBadge from './themes/new-badge.css'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import KPIChartRankingTable from './kpi-chart-ranking-table.jsx'
import KPIChartDetailTable from './kpi-chart-detail-table.jsx'
import successButtonTheme from './themes/success-button.css'
import Circle from 'react-circle'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { v4 as uuidv4 } from 'uuid';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'
import Link from 'react-toolbox/lib/link'
import FontIcon from 'react-toolbox/lib/font_icon'
import Tooltip from 'react-toolbox/lib/tooltip'
const TooltipButton = Tooltip(Button)

function KPIChart(props){
  const {
    t,
    kpi,
    kpis,
    comparison_kpis,
    selectedKPIs,
    periodType,
    ui,
    monthly,
    onClickLegend,
    width,
  } = props

  let data;

  if (ui.isComparison) {
    data = calcComparisonHighchartData(comparison_kpis, t, ui);
  } else {
    data = ui.chartType == 'pie'
      ? calcPieHighchartData(selectedKPIs, kpis, t, ui)
      : calcColumnLineHighchartData(selectedKPIs, kpis, t, periodType, ui);
  }

  return (<ChartView config={data} />)
}

const chartTypeList = [
  { value: 'column', label: '棒グラフ' },
  { value: 'line', label: '折れ線グラフ' },
  { value: 'pie', label: '円グラフ' }
]

const aggregationTypeList = [
  { value: 'cumulative', label: '累計' },
  { value: 'daily_total_01', label: '日毎一覧' },
  { value: 'daily_total_02', label: '日毎累積' }
]

const linkURL = 'https://support.getgamba.com/hc/ja/articles/42544928549017'

// Define each sortable item with the DragHandle
const SortableKPIItem = SortableElement(({ selectedKPI, onRemoveKPI, props }) => (
  <div className={kpiTheme.kpiItem} style={{ backgroundColor: '#f9fafb' }}>
    <div className={kpiTheme.kpiTitle}>{selectedKPI.label}</div>
    <IconButton style={{ color: 'rgb(117, 117, 117)' }}
      icon="close"
      className={kpiTheme.removeBtn}
      onClick={() => onRemoveKPI(selectedKPI.id, props)}
    />
  </div>
))

// Define the sortable list container
const SortableKPIList = SortableContainer(({ selectedKPIs, onRemoveKPI, props }) => (
  <div>
    {selectedKPIs.map((selectedKPI, index) => (
      <SortableKPIItem
        key={selectedKPI.id}
        index={index}
        selectedKPI={selectedKPI}
        onRemoveKPI={onRemoveKPI}
        props={props}
      />
    ))}
  </div>
));

class KPIChatPage extends PureComponent {
  constructor() {
    super()
    this.selectUser = (index)=> {
      this.props.updateUI({ selected_user_id: index.dataKey != 'percent' && index.dataKey || undefined })
    }
    // Bind the generateKPIPDF method to the current instance
    this.generateKPIPDF = this.generateKPIPDF.bind(this);
    this.generateKPIPNG = this.generateKPIPNG.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { kpi } = this.props;

    // Check if the kpi changed or was set and selectedKPIs is still empty and add current KPI as default
    if ((kpi && kpi != prevProps.kpi) || (kpi && this.props.ui.selectedKPIs.length == 0)) {
      const year_list = this.getYearList(kpi.start_date, kpi.end_date)
      this.props.updateUI({ selectedKPIs: [{ id: uuidv4(), kpi_id: kpi.kpi_id, label: kpi.name, year: year_list[year_list.length - 1].value, year_list: year_list }] });
      // Set kpiStartDate and kpiEndDate of current kpi
      this.props.updateUI({
        kpiStartDate: moment(kpi.start_date),
        kpiEndDate: moment(kpi.end_date),
        isCumulative: kpi.accumulated_total,
        aggregationType: kpi.accumulated_total ? 'cumulative' : 'daily_total_01',
        tableSelectedDate: moment(kpi.start_date),
        tableStartDate: moment(kpi.start_date),
        tableEndDate: moment(kpi.end_date)
      })
    }
  }

  generateKPIPDF = async (kpi_name) => {
    const file_name = kpi_name + "_kpi_progress.pdf";
    const chartDiv = document.getElementById('chartContainer');

    const kpiTitle = document.getElementById('kpi_title');
    const kpiPeriod = document.getElementById('kpi_period');
      
    if (!chartDiv || !kpiTitle || !kpiPeriod) {
      return;
    }

		const imgs = chartDiv.getElementsByTagName('img');

    for (let img of imgs) {
      if (img.parentElement) {
        img.parentElement.style.display = 'none'; // Hide avatar img
      }
    }
    kpiTitle.style.display = 'block'; // Display kpi title
    kpiPeriod.style.display = 'block'; // Display kpi period

    const chartCanvas = await html2canvas(chartDiv, { scale: 1, useCORS: true });

    for (let img of imgs) {
      if (img.parentElement) {
        img.parentElement.style.display = 'inline-block'; // Display avatar img
      }
    }
    kpiTitle.style.display = 'none'; // Hide kpi title
    kpiPeriod.style.display = 'none'; // Hide kpi peroiod

    // Get the image data
    const chartImgData = chartCanvas.toDataURL('image/png');

    // Initialize jsPDF
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [chartCanvas.width, chartCanvas.height]
    });

    // Define margins
    const marginLeft = 30;
    const marginTop = 30;
    const marginBottom = 30;

    // Calculate the available width and height considering the margins
    const availableWidth = pdf.internal.pageSize.getWidth() - (marginLeft * 2);
    const availableHeight = pdf.internal.pageSize.getHeight() - marginTop - marginBottom;

    // Calculate the scale factor based on the available width and height
    let chartScale = Math.min(
      availableWidth / chartCanvas.width,
      availableHeight / chartCanvas.height
    );

    // Add the image to the PDF using the scale factor and margins for x and y coordinates
    pdf.addImage(chartImgData, 'PNG', marginLeft, marginTop, chartCanvas.width * chartScale, chartCanvas.height * chartScale);

    // Save the PDF with chartContainer
    pdf.save(file_name);
  }

  generateKPIPNG = async (kpi_name) => {
    const file_name = kpi_name + "_kpi_progress.png";
    
    const svgDiv = document.getElementById('svgContainer');
    const svgCanvas = await html2canvas(svgDiv, { scale: 1, useCORS: true });

    // Get the image data URL
    const svgImgData = svgCanvas.toDataURL('image/png');

    // Create a link element
    const link = document.createElement('a');
    link.href = svgImgData;
    link.download = file_name;

    // Append link to the body
    document.body.appendChild(link);

    // Trigger click event on the link to start the download
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
  }

  getYearList = (start_date, end_date) => {
    const startYear = moment(start_date).year();
    const endYear = moment(end_date).year();
    const years = [];

    for (let year = startYear; year <= endYear; year++) {
      years.push({ value: year.toString(), label: `${year.toString()} 年`});
    }
    return years;
  }

  onAddKPI = (kpi_id, props)=> {
    if (kpi_id == 0) return; // Do nothing if the initial value is selected

    // Find the selected KPI object from the list of KPIs
    const selectedKPI = this.props.group_kpis.find(item => item.kpi_id == kpi_id)
    const year_list = this.getYearList(selectedKPI.start_date, selectedKPI.end_date)

    const updatedKPIs = [...this.props.ui.selectedKPIs, { id: uuidv4(), kpi_id: kpi_id, label: selectedKPI.name, year: year_list[year_list.length - 1].value, year_list: year_list }];
    
    this.props.updateUI({ selectedKPIs: updatedKPIs });
    this.props.fetchChartKpis(updatedKPIs, props);
    this.props.fetchComparisonKpis(updatedKPIs, props);
  } 

  onRemoveKPI = (id, props) => {
    const updatedKPIs = this.props.ui.selectedKPIs.filter(k => k.id !== id);

    this.props.updateUI({ selectedKPIs: updatedKPIs });
    this.props.fetchComparisonKpis(updatedKPIs, props);
  }

  onUpdateKPIDate = (dateType, date) => {
    this.props.updateUI({ [dateType]: date });
  }
  
  onChangeComparisonYear = (id, year, props) => {
    // Update only the specific KPI in the selectedKPIs array in a single pass
    const updatedKPIs = this.props.ui.selectedKPIs.map(kpi =>
      kpi.id == id ? { ...kpi, year: year } : kpi
    );

    this.props.updateUI({ selectedKPIs: updatedKPIs });
    this.props.fetchComparisonKpis(updatedKPIs, props);
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { selectedKPIs } = this.props.ui;
    const newOrder = arrayMove(selectedKPIs, oldIndex, newIndex);
    this.props.updateUI({ selectedKPIs: newOrder });
  }

  render() {
    const {
      t,
      ui,
      updateActualRecord,
      isFetching,
      isFetchFailed,
      isUpdating,
      isUpdateFailed,
      kpis,
      group_kpis,
      comparison_kpis,
      kpi,
      user,
      group,
      updateUI,
      openKPIChartPage,
      openGroupKPIPanel,
      fetchChartKpis,
      fetchComparisonKpis,
    } = this.props

    const otherKpis = kpi && kpis && _.filter(kpis, (item)=> item.kpi_id != kpi.kpi_id)
    const kpi_name = kpi && kpi.name || '';

    let { selectedKPIs } = ui;
    
    let dropDownKPISource = [
      { value: 0, label: t('label:KPIを追加') }
    ]

    if (kpi && group_kpis) {
      const groupKPIOptions = group_kpis
        .map(item => ({
          value: item.kpi_id,
          label: item.name
        }));

      // Concatenate KPI options with the default option initially
      dropDownKPISource = dropDownKPISource.concat(groupKPIOptions);
    }

    return (
      <RightSidePage
        title={t('label:KPIの進捗状況', { name: kpi && kpi.name || '' })}
        icon="insert_chart"
        rightAction={[
          !ui.selected_user_id &&
          <IconMenu icon='download' position='topRight'>
            <MenuItem caption={t('label:PDFで保存')} onClick={() => this.generateKPIPDF(kpi_name)} icon="content_copy" />
          	<MenuItem caption={t('label:画像で保存')} onClick={() => this.generateKPIPNG(kpi_name)} icon="image" />
          </IconMenu>
        ]} >
        <List selectable className={kpiTheme.whiteDiv}>
          <ListItem
            className={`${kpiTheme.settingTitle} ${ui.showKPIDataSetting ? '' : kpiTheme.closed}`}
            caption={t('label:KPIデータ設定')}
            selectable={true}
            rightIcon={ui.showKPIDataSetting && "expand_less" || "expand_more"}
            onClick={()=> {
              !ui.showKPIDataSetting
              updateUI({ showKPIDataSetting: !ui.showKPIDataSetting })
            }}
          />
          {ui.showKPIDataSetting &&
          <div className={kpiTheme.settingWrap}>
            <CardText className={kpiTheme.itemWrap}>
              <div className={kpiTheme.itemTitle}>{t('label:開始日')}&nbsp;/&nbsp;{t('label:終了日')}</div>
              {ui.kpiStartDate && ui.kpiEndDate &&
                <div style={{ display: 'flex' }} className={ui.isComparison ? kpiTheme.disabledDatePicker : ''}>
                  <div className={kpiTheme.dateItem}>
                    <DatePicker label={t('label:開始日')}
                      value={ui.kpiStartDate.toDate()}
                      maxDate={ui.kpiEndDate.toDate()}
                      onChange={(date)=> this.onUpdateKPIDate('kpiStartDate', moment(date))} />
                  </div>
                  <div>&nbsp;&nbsp;</div>
                  <div className={kpiTheme.dateItem}>
                  <DatePicker label={t('label:終了日')}
                    value={ui.kpiEndDate.toDate()}
                    minDate={ui.kpiStartDate.toDate()}
                    onChange={(date)=> this.onUpdateKPIDate('kpiEndDate', moment(date))} />
                  </div>
                </div>
              }
            </CardText>
            <CardText className={kpiTheme.itemWrap}>
              <div className={kpiTheme.itemTitle}>{t('label:データ選択')}</div>
              <SortableKPIList
                selectedKPIs={selectedKPIs}
                onRemoveKPI={this.onRemoveKPI}
                onSortEnd={this.onSortEnd}
                props={this.props}
                lockAxis="y" // locks movement to the vertical axis
              />
              <DropDown auto
                className={kpiTheme.dropDownList}
                source={dropDownKPISource}
                value={0} // Show the default selected option
                onChange={(value) => this.onAddKPI(value, this.props)}
              />
            </CardText>
          </div>
          }
          <div style={{ display: 'flex', paddingTop: 15 }}>
            <DropDown auto
              className={kpiTheme.chartTypeDropDownList}
              source={chartTypeList}
              value={ui.chartType}
              onChange={(value) => updateUI({ chartType: value })}
            />
            <Link
              href={linkURL}
              target={"_blank"}
              rel={"noopener noreferrer"}
              style={{ display: 'inline', textDecoration: 'none', opacity: 1 }}
            >
              <div style={{ fontSize: 16, color: '#306ced', marginLeft: 15 }}>
                <FontIcon value='info' className={kpiTheme.buttonFontIcon}/>{t('label:使い方')}
              </div>
            </Link>              
          </div>
          <div style={{ display: 'flex', paddingTop: 10, paddingBottom: 10, marginLeft: 10 }}>
            <Checkbox
              label={<TooltipButton neutral={false} ripple={false} className="touchable"
                      style={{ color: (ui.isIndividual ||ui.isConversion || ui.isComparison) ? '#00000042' : 'black' }}
                      tooltipPosition="left"
                      theme={kpiTheme}
                      tooltip={<div><FontIcon value='info' className={kpiTheme.fontIcon}/><span>{t('label:累計説明')}</span></div>}
                      label={t('label:累計')}/>}
              className={kpiTheme.checkBox}
              checked={ui.isCumulative}
              disabled={(ui.isIndividual ||ui.isConversion || ui.isComparison) ? true : false}
              onChange={() => updateUI({ isCumulative: !ui.isCumulative })}/>
            <Checkbox
              label={<TooltipButton neutral={false} ripple={false} className="touchable"
                      style={{ color: (ui.isConversion || ui.isComparison || ui.isCumulative) ? '#00000042' : 'black' }}
                      tooltipPosition="left"
                      theme={kpiTheme}
                      tooltip={<div><FontIcon value='info' className={kpiTheme.fontIcon}/><span>{t('label:個人データ説明')}</span></div>}
                      label={t('label:個人データ')}/>}
              className={kpiTheme.checkBox}
              checked={ui.isIndividual}
              disabled={(ui.isConversion || ui.isComparison || ui.isCumulative) ? true : false}
              onChange={() => updateUI({ isIndividual: !ui.isIndividual, isConversion: false, isComparison: false })}/>
            {ui.chartType == 'column' &&
              <Checkbox
                label={<TooltipButton neutral={false} ripple={false} className="touchable"
                        style={{ color: ui.isConversion ? '#00000042' : 'black' }}
                        tooltipPosition="left"
                        theme={kpiTheme}
                        tooltip={<div><FontIcon value='info' className={kpiTheme.fontIcon}/><span>{t('label:積み上げ説明')}</span></div>}
                        label={t('label:積み上げ')}/>}
                className={kpiTheme.checkBox}
                checked={ui.isStacked}
                disabled={ui.isConversion ? true : false}
                onChange={() => updateUI({ isStacked: !ui.isStacked, isConversion: false, isComparison: false })}/>
            }
            <Checkbox
              label={<TooltipButton neutral={false} ripple={false} className="touchable"
                      style={{ color: (ui.isStacked || ui.isIndividual || ui.isCumulative) ? '#00000042' : 'black' }}
                      tooltipPosition="left"
                      theme={kpiTheme}
                      tooltip={<div><FontIcon value='info' className={kpiTheme.fontIcon}/><span>{t('label:歩留まり説明')}</span></div>}
                      label={t('label:歩留まり')}/>}
              className={kpiTheme.checkBox}
              checked={ui.isConversion}
              disabled={(ui.isStacked || ui.isIndividual || ui.isCumulative) ? true : false}
              onChange={() => updateUI({ isConversion: !ui.isConversion, isStacked: false, isIndividual: false, isComparison: false })}/>
            <Checkbox
              label={<TooltipButton neutral={false} ripple={false} className="touchable"
                      style={{ color: (ui.isStacked || ui.isIndividual || ui.isConversion || ui.isCumulative) ? '#00000042' : 'black' }}
                      tooltipPosition="left"
                      theme={kpiTheme}
                      tooltip={<div><FontIcon value='info' className={kpiTheme.fontIcon}/><span>{t('label:比較説明')}</span></div>}
                      label={t('label:比較')}/>}
              className={kpiTheme.checkBox}
              checked={ui.isComparison}
              disabled={(ui.isStacked || ui.isIndividual || ui.isConversion || ui.isCumulative) ? true : false}
              onChange={() => updateUI({ isComparison: !ui.isComparison, isIndividual: false, index: !ui.isComparison ? 1 : 0 })}/>
          </div>
          {ui.isComparison &&
          <div style={{ marginTop: 10 }}>
            <FontIcon value='info' style={{ verticalAlign: 'bottom', marginLeft: 15, marginBottom: -2 }}/>
            <span style={{ marginLeft: 5 }}>{t('label:比較説明メッセージ')}</span>
          </div>
          }
          {ui.isComparison &&
            <div className={kpiTheme.kpiComparisonItem}>
              {selectedKPIs.map(selectedKPI => (
                <div key={selectedKPI.id} className={kpiTheme.kpiItem} style={{ cursor: 'default' }}>
                  <div className={kpiTheme.kpiComparisonName}>{selectedKPI.label}</div>
                  <DropDown auto
                    className={kpiTheme.dropDownList}
                    source={selectedKPI.year_list}
                    value={selectedKPI.year}
                    onChange={(year) => this.onChangeComparisonYear(selectedKPI.id, year, this.props)}
                  />
                </div>
              ))}
            </div>
          }
        </List>

        {!isFetchFailed && isFetching && <Loading /> }
        <div id="chartContainer" className={kpiTheme.whiteDiv}>
          <p id="kpi_title" style={{ fontSize: 18, fontWeight: 'bold', display: 'none'}}>{kpi_name} KPIの進捗状況</p>
          <div id="svgContainer">
          {!isFetchFailed && !isFetching && kpis && (
            <Tabs theme={tabTheme} index={ui.index} onChange={(index)=> updateUI({ index })} className={kpiTheme.navItem}>
              <Tab label={t('label:日次')} className={kpiTheme.dayItem} disabled={ui.isComparison}>
                <KPIChart
                  t={t}
                  kpi={kpi}
                  kpis={kpis}
                  comparison_kpis={comparison_kpis}
                  ui={ui}
                  selectedKPIs={selectedKPIs}
                  periodType={'daily'}
                  onClickLegend={this.selectUser}
                />
              </Tab>
              <Tab label={t('label:月次')} className={kpiTheme.monthItem}>
                <KPIChart
                  t={t}
                  kpi={kpi}
                  kpis={kpis}
                  comparison_kpis={comparison_kpis}
                  ui={ui}
                  selectedKPIs={selectedKPIs}
                  periodType={'monthly'}
                  onClickLegend={this.selectUser}
                />
              </Tab>
              <Tab label={t('label:年次')} className={kpiTheme.yearItem} disabled={ui.isComparison}>
                <KPIChart
                  t={t}
                  kpi={kpi}
                  kpis={kpis}
                  comparison_kpis={comparison_kpis}
                  ui={ui}
                  selectedKPIs={selectedKPIs}
                  periodType={'yearly'}
                  onClickLegend={this.selectUser}
                />
              </Tab>
            </Tabs>
          )}
          </div>
          {!isFetchFailed && !isFetching && kpis && !ui.isComparison &&
          <div id="kpi_period" className={kpiTheme.aggregationDatesWrap}>
            <DropDown auto
              className={kpiTheme.aggregationTypeList}
              source={aggregationTypeList}
              value={ui.aggregationType}
              onChange={(value) => updateUI({ aggregationType: value })}
            />
            {ui.tableSelectedDate && !ui.selected_user_id && (ui.aggregationType == 'daily_total_01' || ui.aggregationType == 'daily_total_02') &&
            <div className={kpiTheme.dateButton}>
              <div style={{ paddingTop: 7, marginRight: 5 }}>{t('label:集計日')}:</div>
              <DatePicker
                value={ui.tableSelectedDate.toDate()}
                minDate={ui.kpiStartDate.toDate()}
                maxDate={ui.kpiEndDate.toDate()}
                onChange={(date)=> updateUI({ tableSelectedDate: moment(date) })}
              />
            </div>
            }
            {ui.tableStartDate && ui.tableEndDate && ((!ui.selected_user_id && ui.aggregationType == 'cumulative') || ui.selected_user_id) &&
            <div className={kpiTheme.dateButton}>
              <div style={{ paddingTop: 7, marginRight: 5 }}>{t('label:集計期間')}:</div>
              <DatePicker
                value={ui.tableStartDate.toDate()}
                minDate={ui.kpiStartDate.toDate()}
                maxDate={ui.kpiEndDate.toDate()}
                onChange={(date)=> updateUI({ tableStartDate: moment(date) })}
              />
              <div style={{ paddingTop: 10, marginLeft: 5, marginRight: 5 }}>~</div>
              <DatePicker
                value={ui.tableEndDate.toDate()}
                minDate={ui.tableStartDate.toDate()}
                maxDate={ui.kpiEndDate.toDate()}
                onChange={(date)=> updateUI({ tableEndDate: moment(date) })}
              />
            </div>
            }
          </div>
          }          
          {!isFetchFailed && !isFetching && kpis && !ui.selected_user_id && !ui.isComparison &&
          <div id="tableContainer" style={{ padding: 15, overflow: 'auto' }}>
            <KPIChartRankingTable
              selectUser={(user_id, user_name)=> group && updateUI({ selected_user_id: user_id, selected_user_name: user_name })}
              selectedKPIs={selectedKPIs}
              kpis={kpis}
              kpiUI={ui}
            />
          </div>
          }
          {!isFetchFailed && !isFetching && kpis && ui.selected_user_id && group && !ui.isComparison &&
            <KPIChartDetailTable kpi={kpi}
                  width={ui.clientWidth}
                  selected_user_id={ui.selected_user_id}
                  selected_user_name={ui.selected_user_name}
                  selectedKPIs={selectedKPIs}
                  fetchChartKpis={fetchChartKpis}
                  fetchComparisonKpis={fetchComparisonKpis}
                  parentProps={this.props}
                  kpis={kpis}
                  kpiUI={ui}
                  user={user}
                  group={group}
                  onClose={()=> updateUI({ selected_user_id: undefined })} />
          }
        </div>
        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:KPIの取得に失敗しました')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawKPIChatPage = KPIChatPage
export default connect(KPIChatPage)



// WEBPACK FOOTER //
// ./src/web/components/kpi-chart-page.jsx